let companies = [
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Alpha-9 Theranostics",
    location: "Vancouver, Canada",
    university: "University of British Columbia, Vancouver, Canada",
    categoryList: ["Cancer", "Diagnostics", "Medical imaging"],
    URL: "https://www.alpha9tx.com/",
    description:
      "Imaging agents for positron emission tomography (PET) scans to help diagnose cancer.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "AltrixBio",
    location: "Cambridge, Massachusetts",
    university:
      "Brigham & Women's Hospital, Harvard Medical School, Boston, United States;  Broad Institute, Cambridge, Massachusetts",
    categoryList: ["Diabetes", "Nutrition", "Obesity"],
    URL: "https://altrixbio.com/",
    description:
      "Drug for type 2 diabetes and obesity that works by modulating nutrient contact with the bowel mucosa and thereby lowering the glucose response.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Amferia",
    location: "Mölndal, Sweden",
    university: "Chalmers University of Technology, Gothenburg, Sweden",
    categoryList: [
      "Antibiotics",
      "Infectious diseases",
      "Materials and nanotechnology",
    ],
    URL: "https://amferia.com/",
    description:
      "Wound care patch and spray that can kill bacteria and prevent infections in skin wounds.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Avotres",
    location: "Cedar Knolls, New Jersey",
    university: "Columbia University, New York City",
    categoryList: ["Autoimmune disease", "Therapeutics", ""],
    URL: "https://www.avotres.com/",
    description:
      "Cell therapies for type 1 diabetes and other autoimmune diseases, with potential applications in transplantation and certain forms of cancer.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "BeFC - Bioenzymatic Fuel Cells",
    location: "Gières, France",
    university: "Université Grenoble Alpes, Saint-Martin-d'Hères, France",
    categoryList: ["Medical devices", "Energy", ""],
    URL: "https://befc.global/",
    description:
      "Bioenzymatic fuel cell power sources using enzymes and carbon paper provide power for wearable and disposable electronics such as continuous glucose monitors for diabetes and digital pregnancy tests.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01797-5",
    name: "CageCapture",
    location: "Liverpool, UK",
    university: "University of Liverpool, UK",
    categoryList: ["Materials and nanotechnology", "Environment", ""],
    URL: "https://cagecapture.com/",
    description:
      "Advanced material technology in which porous organic cage molecules capture sub-nanometre-size pollutants such as formaldehyde 500 times more effectively than activated carbon.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Cardio Diagnostics",
    location: "Coralville, Iowa",
    university: "University of Iowa, US",
    categoryList: ["Heart disease", "Diagnostics", ""],
    URL: "https://cardiodiagnosticsinc.com/",
    description:
      "Asseses genetic and epigenetic DNA markers to monitor a patient's risk for heart disease.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01798-4",
    name: "Caristo Diagnostics",
    location: "Oxford, UK",
    university: "University of Oxford, UK",
    categoryList: ["Heart disease", "Diagnostics", "Digital"],
    URL: "https://www.caristo.com/",
    description:
      "Software for analysis of cardio computed tomography (CT) scans to identify vascular inflammation and the risk of heart attack.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "ChromaTwist",
    location: "Birmingham, UK",
    university: "University of Birmingham, UK",
    categoryList: ["Medical imaging", "Diagnostics", ""],
    URL: "https://chromatwist.com/",
    description:
      "Developing fluorophores to be used in single and multiphoton bioprobes in flow cytometry and live tissue imaging.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Comptek Solutions",
    location: "Turku, Finland",
    university: "University of Turku, Finland",
    categoryList: ["Electronics", "Medical devices", ""],
    URL: "https://www.comptek-solutions.com/",
    description:
      "Technology to improve manufacturing yields and boost the efficiency of compound semiconductor devices such those used in lasers, light-emitting diodes (LEDs) and photodetectors.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Cybrexa Therapeutics",
    location: "New Haven, Connecticut",
    university: "Yale University, New Haven, Connecticut",
    categoryList: ["Cancer", "Drug development", "Therapeutics"],
    URL: "http://www.cybrexa.com/",
    description:
      "Technology that allows small-molecule anti-cancer agents to penetrate cell membranes only at the low pH characteristic of the tumour microenvironment, thus selectively releasing drug molecules directly within tumour cells while limiting toxicity to healthy tissue.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Dynocardia",
    location: "Cambridge, Massachusetts",
    university: "Tufts University, Medford, Massachusetts",
    categoryList: ["Medical devices", "", ""],
    URL: "https://www.dynocardia.care/",
    description:
      "Technology for continuous, non-invasive blood pressure monitoring.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Elypta",
    location: "Stockholm, Sweden",
    university: "Chalmers University of Technology, Gothenburg, Sweden",
    categoryList: ["Cancer", "Diagnostics", ""],
    URL: "https://elypta.com/",
    description:
      "Liquid biopsies to detect cancer based on metabolite biomarkers.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01799-3",
    name: "EpiVario",
    location: "Philadelphia, Pennsylvania",
    university: "University of Pennsylvania, Philadelphia",
    categoryList: ["Neuroscience", "Therapeutics", "Drug development"],
    URL: "http://epivario.com/",
    description:
      "Drug to treat post-traumatic stress disorder by blocking the consolidation of traumatic memories in the brain.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Equal 1 Laboratories",
    location: "Dublin, Ireland",
    university: "University College Dublin, Ireland",
    categoryList: ["Digital", "", ""],
    URL: "https://equal1.us/",
    description:
      "Qubits (or quantum bits) for what could be the world's first desktop quantum computer.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01800-z",
    name: "EraCal Therapeutics",
    location: "Zollikon, Switzerland",
    university:
      "University of Zurich, Switzerland; Harvard University, Cambridge, Massachusetts",
    categoryList: ["Obesity", "Drug development", "Diabetes"],
    URL: "https://www.eracal.ch/",
    description:
      "Drug to help people control their weight by suppressing their appetite.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01801-y",
    name: "Forkhead BioTherapeutics",
    location: "New York City, New York",
    university: "Columbia University, New York City",
    categoryList: ["Diabetes", "Drug development", ""],
    URL: "https://www.forkheadbio.com/",
    description:
      "An oral drug for treating insulin-dependent diabetes by turning certain gut cells into β-like cells that produce insulin in response to blood glucose levels.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "InSignals Neurotech",
    location: "Porto, Portugal",
    university:
      "INESC TEC - Institute for Systems and Computer Engineering, Technology and Science, Porto, Portugal",
    categoryList: ["Neuroscience", "Medical devices", "Parkinson's"],
    URL: "http://www.insignals-neurotech.com/",
    description:
      "Wearable device to sense wrist rigidity to aid the placement of electrodes during deep brain stimulation surgery to treat Parkinson's disease.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "iPronics",
    location: "València, Spain",
    university: "Universitat Politècnica de València, Spain",
    categoryList: ["Medical imaging", "Electronics", "Photonics"],
    URL: "https://ipronics.com/",
    description:
      "General-purpose photonic processors capable of programming high-speed light signals on-chip for applications such as 5G communication, autonomous driving, quantum computing and the Internet of things.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Isolere Bio",
    location: "Durham, North Carolina",
    university: "Duke University, Durham, North Carolina",
    categoryList: ["Drug development", "Drug delivery", ""],
    URL: "http://www.isolerebio.com",
    description:
      "Chromatography-free purification solutions to improve productivity, lower cost and simplify scale-up in the production of therapeutics such as monoclonal antibodies and gene therapies.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Kebotix",
    location: "Cambridge, Massachusetts",
    university: "Harvard University, Cambridge, Massachusetts",
    categoryList: ["Digital", "Research tools", ""],
    URL: "https://www.kebotix.com/",
    description:
      "Artificial-intelligence (AI) system to guide chemistry research, from proposing new molecules with specific properties to designing a robot-assisted laboratory workflow to synthesize these molecules.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Liposphere",
    location: "Ness Ziona, Israel",
    university: "Weizmann Institute of Science, Rehovot, Israel",
    categoryList: ["Materials and nanotechnology", "Orthopedics", ""],
    URL: "https://www.lipo-sphere.com/",
    description:
      "Biolubricants for use in applications such as artificial knees and hips.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Matricelf",
    location: "Tel Aviv, Israel",
    university: "Tel Aviv University, Israel",
    categoryList: ["Tissue engineering", "Spinal cord injury", "Stem cells"],
    URL: "https://matricelf.com/",
    description:
      "Combining stem cell research with tissue engineering technologies to develop personalized treatments for a variety of indications including myocardial infarction, spinal cord injury, age-related macular degeneration and Parkinson's disease.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "MEDPNC",
    location: "Herzliya, Israel",
    university: "The Hebrew University of Jerusalem, Israel",
    categoryList: ["Cancer", "Diagnostics", "Precision medicine"],
    URL: "https://www.medpnc.com/",
    description:
      "In people with cancer, networks of altered protein–protein relationships generate a flow of information, which direct the tumour cells' development and progression. MEDPNC deciphers the structure of these networks in each individual patient and predicts the optimal personalized drug combinations for treatment.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01802-x",
    name: "MiWEndo Solutions",
    location: "Barcelona, Spain",
    university:
      "Universitat Pompeu Fabra, Hospital Clinic of Barcelona, Poletechnic University of Catalonia, Catalan Institute for Research and Advanced Studies, Spain",
    categoryList: ["Medical imaging", "Cancer", "Medical devices"],
    URL: "https://www.miwendo.com/",
    description:
      "A medical device to integrate microwave technologies with conventional colonoscopy. The technology identifies polyps 360º inside the colon without changing the clinical practice and diagnoses the grade of dysplasia of such identified polyps.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Mushroom-X",
    location: "Hong Kong",
    university: "The Chinese University of Hong Kong",
    categoryList: ["Agriculture", "Materials and nanotechnology", "Nutrition"],
    URL: "https://www.mushroom-x.com/",
    description:
      "Developing a system to manage mushroom growth for food and turning the waste from the fungus into biomaterials to replace plastic and construction materials.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Nano Red",
    location: "Madison, Wisconsin",
    university: "National Cancer Institute, Bethesda, Maryland",
    categoryList: ["Cancer", "Immunotherapy", "Drug delivery", "Therapeutics"],
    URL: "http://www.nanoredbiotech.com",
    description: "Precision delivery of cancer immunotherapies.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Nanovatif Materials Technologies",
    location: "Ankara, Turkey",
    university: "Middle East Technical University, Ankara, Turkey",
    categoryList: ["Materials and nanotechnology", "", ""],
    URL: "http://www.thermalera.com/",
    description:
      "Battery heated clothing made possible by integrating silver nanowires into fabrics.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Noisy Guts",
    location: "Perth, Australia",
    university: "The University of Western Australia, Perth",
    categoryList: ["Diagnostics", "Medical devices", ""],
    URL: "http://www.noisyguts.net/",
    description:
      "Makes an acoustic belt that listens, records and analyses gut noises, using algorithms to non-invasively diagnose and monitor irritable bowel syndrome and other gut disorders.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01803-w",
    name: "Oxford Brain Diagnostics",
    location: "Oxford, UK",
    university: "University of Oxford, UK",
    categoryList: ["Neuroscience", "Alzheimer's", "Diagnostics"],
    URL: "https://www.oxfordbraindiagnostics.com/",
    description:
      "Enhanced magnetic resonance imaging (MRI) system for early diagnosis of dementia.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Parity Quantum Computing",
    location: "Innsbruck, Austria",
    university: "University of Innsbruck, Austria",
    categoryList: ["Digital", "Drug development", ""],
    URL: "https://parityqc.com/",
    description:
      "Develops blueprints for quantum computers to solve optimization problems as well as the appertaining software called ParityOS, which can be used to solve optimization problems",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "PetMedix",
    location: "Cambridge, UK",
    university: "Wellcome Sanger Institute, Hinxton, UK",
    categoryList: ["Veterinary", "Drug development", ""],
    URL: "https://www.petmedix.co.uk/",
    description: "Monoclonal antibodies to treat disease in dogs and cats.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01804-9",
    name: "PredictImmune",
    location: "Cambridge, UK",
    university: "University of Cambridge, UK",
    categoryList: [
      "Autoimmune disease",
      "Diagnostics",
      "Inflammatory bowel disease",
    ],
    URL: "https://www.predictimmune.com/",
    description:
      "Prognostic tests for immune-mediated and autoimmune diseases.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Proteona",
    location: "Singapore",
    university: "National University of Singapore",
    categoryList: ["Cancer", "Diagnostics", "Multiple myeloma"],
    URL: "https://proteona.com/",
    description:
      "Tool that uses artificial-intelligence (AI) algorithms to analyse bone-marrow biopsy data as a way to help physicians choose a personalized treatment approach for people with the blood cancer multiple myeloma.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "ResQ Biotech",
    location: "Patras, Greece",
    university: "National Hellenic Research Foundation, Athens, Greece",
    categoryList: [
      "Drug development",
      "Alzheimer's",
      "Amyotrophic lateral sclerosis",
    ],
    URL: "https://www.resqbiotech.com/",
    description:
      "Developing genetically engineered drugs to treat amyotrophic lateral sclerosis and other protein-misfolding diseases.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "REVIVO BioSystems",
    location: "Singapore",
    university:
      "Agency for Science, Technology and Research (A*STAR), Singapore",
    categoryList: ["Drug development", "Organ-on-chip", ""],
    URL: "https://www.revivobio.com",
    description:
      "Organ-on-a-chip platforms to help cosmetic and pharmaceutical research laboratories screen the safety and efficacy of chemicals and formulations reliably and efficiently, replacing animal testing.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "RJH Biosciences",
    location: "Edmonton, Canada",
    university: "University of Alberta, Canada",
    categoryList: ["Cancer", "Gene therapy", "Drug delivery"],
    URL: "https://www.rjhbiosciences.com/",
    description:
      "Packages therapeutic nucleic acids in virus-like nanoparticles, enabling delivery of specific types of nucleic acids to specific types of cells.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01805-8",
    name: "Scailyte",
    location: "Sursee, Switzerland",
    university: "ETH Zurich, Switzerland",
    categoryList: ["Digital", "Diagnostics", "Cancer"],
    URL: "https://scailyte.com/",
    description:
      "Machine learning algorithm to develop a new class of diagnostic biomarker that uses molecular signatures to characterize a single cell's identity. Such biomarkers could help researchers to understand the function of rare, uncharacterized and previously unknown cell types and thus point towards potential new disease therapies.",
  },
  {
    status: true,
    winner: true,
    profileURL: "https://www.nature.com/articles/d41586-020-01806-7",
    name: "Sibel Health",
    location: "Niles, Illinois",
    university: "Northwestern University, Evanston, Illinois",
    categoryList: ["Medical devices", "Digital", ""],
    URL: "http://www.sibelhealth.com/",
    description:
      "Networked wireless sensor system to monitor neonatal vital signs (including electrocardiogram data, blood flow volume and skin temperature) in real-time with clinical-grade precision.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01807-6",
    name: "Softsonics",
    location: "San Diego, California",
    university: "University of California San Diego",
    categoryList: ["Medical devices", "Blood  pressure", ""],
    URL: "http://curescendo.com/",
    description:
      "Ultrasound wearable device to measure accurately, continuously and non-invasively the blood pressure waveform. The device allows blood pressure to be recorded within deep arteries continuously without the need for clinical staff supervision.",
  },
  {
    status: true,
    winner: false,
    profileURL: "https://www.nature.com/articles/d41586-020-01808-5",
    name: "Temprian Therapeutics",
    location: "Chicago, Illinois",
    university: "Northwestern University, Chicago, Illinois",
    categoryList: ["Vitiglio", "Drug development", "Autoimmune disease"],
    URL: "https://tempriantherapeutics.com/",
    description: "Treatment for vitiligo.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Trobix Bio",
    location: "Netanya, Israel",
    university: "Ramot at Tel-Aviv University, Israel",
    categoryList: ["Antibiotics", "Drug development", ""],
    URL: "https://www.trobixbio.com/",
    description:
      "Therapies targeted to remove the threat of antimicrobial resistance. The company’s lead product, TBX101, aims to treat patients carrying gut antimicrobial-resistant bacteria, resulting in an antibiotic sensitive gut microbiome.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "uFraction8",
    location: "Falkirk, UK",
    university: "Heriot-Watt University, Edinburgh, UK",
    categoryList: ["Microfluidics", "Research tools", ""],
    URL: "http://www.ufraction8.com/",
    description:
      "Developing a system that uses arrays of microfluidic separation devices for application in harvesting biological cells from large scale culture or fermentation operations such as those used in the production of food, nutraceuticals, beverages, biofuels, insulin, monoclonal antibodies and therapeutic proteins.",
  },
  {
    status: false,
    winner: false,
    profileURL: false,
    name: "Vivlion",
    location: "Frankfurt am Main, Germany",
    university: "Goethe University Frankfurt, Germany",
    categoryList: ["Gene therapy", "Research tools", ""],
    URL: "https://www.vivlion.com/",
    description:
      "Technology to improve the efficiency of CRISPR gene editing for high-throughput screening.",
  },
];

const reducer = (accumulator, currentValue) => {
  currentValue.categoryList.forEach((category) => {
    if (!accumulator.includes(category) && category.length > 1) {
      accumulator.push(category);
    }
  });
  return accumulator;
};

let categories = companies
  .reduce(reducer, [])
  .sort()
  .map((elem) => {
    return { name: elem, selected: false, disabled: false };
  });

module.exports = { companies, categories };
